export const icons = [
  'arrow_drop_down',
  'calendar_today',
  'check',
  'close',
  'co2',
  'dashboard',
  'finance',
  'paid',
  'progress_activity',
  'schedule',
  'settings',
  'unfold_less',
  'unfold_more',
  'visibility',
  'visibility_off',
] as const;

const Icon = ({
  name,
  className,
  size,
}: {
  name: (typeof icons)[number];
  className?: string;
  size?: 'small';
}) => (
  <span
    className={`material-symbols-rounded${size === 'small' ? ' icon-small' : ''}${className ? ` ${className}` : ''}`}
  >
    {name}
  </span>
);

export default Icon;
